import { render, staticRenderFns } from "./TransferInformation.vue?vue&type=template&id=6e1241ee&scoped=true"
import script from "./TransferInformation.vue?vue&type=script&lang=js"
export * from "./TransferInformation.vue?vue&type=script&lang=js"
import style0 from "./TransferInformation.vue?vue&type=style&index=0&id=6e1241ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1241ee",
  null
  
)

export default component.exports